module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/stemphyllium_tomate/curativa/vigold.png
// module id = 2394
// module chunks = 3